// import { transform } from "@babel/core"
import translate from "./lang"

/*global translate*/
const { rxaget, rxChangeSlug ,changeColorSVG} = global.rootRequire('classes/ulti')
const { rxgetLocal } = global.rootRequire('classes/request')
const worker = global.rootRequire('classes/globalUser')
const chatDB = global.rootRequire('classes/indexedDB').default

export function addContact({ arrContacts = [], udid = '', token, typeForce = 0 }, callback) {
  // try {
  // let address_book_link = global.rxu.config.base_api_neta + '/api/address_book.json'
  //   let params = { "Fullname": arrContacts.Fullname, "Username":arrContacts.Username}
  //   let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': token }
  //   if (params.contacts && params.contacts.length > 0) {
  //     fetch(address_book_link, {
  //       method: 'POST',
  //       body: JSON.stringify(params),
  //       headers: headers
  //     }).then((res) => { return res.json() })
  //       .then((json) => {
  //         callback && callback(json)
  //       }).catch(er => console.log(er))
  //   }
  // } catch (error) { }
}

export function getNumMemberOnl(group,userid){
    let status_list = group.status_list
    let countMemberOnl = 1
    if(status_list){
      for(let i = 0 ; i < status_list.length ;i++ ){
        if(status_list[i].uin !==  userid.toString() && status_list[i].online_status === 1){
          countMemberOnl++
        }
      }
    }
    return countMemberOnl
}

export function changeColorAva(groupid){
  let colors = ['#ED6494', '#65D5D1', '#1BA8D6', '#EFAE62', '#5BBC43', '#EF5B54', '#B27CD3', '#FA944A']

  let sum = ''
  for (let index in groupid) {
    sum += groupid.charCodeAt(index)
  }
  let colorId = Number(sum.substr(sum.length - 3)) % colors.length

  return colors[colorId]
}

export function textAva(str){
  let result = ''
  if (str.indexOf(', ') !== -1) {
    str = str.replace(',', '')
  }
  if (str.indexOf('-') !== -1) {
    str = str.replace('-', ' ')
  }
  let arrStr = str.split(' ')
  if (arrStr && arrStr.constructor === Array) {
    if (arrStr.length === 0) {
      result = 'NL'
    } else if (arrStr.length === 1) {
      result = arrStr[0].slice(0, 2).toUpperCase()
    } else if (arrStr.length > 1) {
      result = (arrStr[0].toString().charAt(0) + arrStr[1].toString().charAt(0)).toUpperCase()
    }
  } else {
    result = 'NL'
  }
  return result
}

export async function fetchContact ({netaContact={},token=''},callback) {    
  if (token) {
    const api_address_book = global.rxu.config.address_book
    const max_size = 300
    let checkBreak = true, newContacts=[]
    for (let i=0; i < 1000; i ++) {
      let offset = (i > 0) ? i*max_size - 1 : 0
      const params = {
        offset: offset,
        limit: max_size,
        compact: 0
      }
      let tempBody = ''
      for (const property in params) {
        if (params.hasOwnProperty(property)) {
          tempBody += `${property}=${params[property]}&`
        }
      }
      try {
        let res = await fetch(api_address_book + '?' + tempBody, { method: 'GET', headers: { Accept: 'application/json', 'TC-Token': token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }, body: null })
        let json = await res.json()
        if (res && [404,401].indexOf(res.status) !== -1) { checkBreak = true }
        else if (json && json.constructor === Array && json.length > 0) {
          // for (let ocontact of json) {
          //   if (typeof(netaContact) === 'object' && typeof(netaContact[ocontact.phone]) === 'undefined') {
              checkBreak = false
          //     break
          //   }
          // }
          newContacts=[...newContacts,...json]
          if (json.length < max_size) { checkBreak = true }
        }
      } catch(e) {
        checkBreak = true 
      }
      if (checkBreak === true) {
        callback && callback(newContacts)
        break 
      }
      await new Promise(r => setTimeout(r, 1000));
    }
  }
}

export async function updateUserProfile () {
  let checkBreak = false
  let netaAuthUser =  global.rxu.json(rxgetLocal('rxuserneta'), { user:{} })
  if (netaAuthUser && netaAuthUser.user && netaAuthUser.user.token) {
    try {
      let token = netaAuthUser.user.token

      let cntUsers = await chatDB.users.count()
      let arrUids = await chatDB.users.orderBy('uid').keys()
      
      let pagingUSers = 100
      let maxPage = Math.floor((cntUsers - 1) / pagingUSers) + 1
      for (let i=0; i < maxPage; i++) {

        if (!checkBreak) {
          try {
            let arrUidsTmp = arrUids.slice(i*pagingUSers, (i+1)*pagingUSers)
      
            let arrUsersDB = await chatDB.users.bulkGet(arrUidsTmp)
            let objUsers = {}
            let arrUpdateUserDB = []

            if (arrUsersDB && arrUsersDB.constructor === Array) {
              arrUsersDB.forEach(oUser => {
                if (oUser && oUser.uid) {
                  objUsers[oUser.uid] = oUser
                }
              })
            }
            
            let requestOptions = {
              method: 'POST', 
              headers: { 'TC-Token': token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }, 
              body: JSON.stringify({ user_ids: arrUidsTmp })
            }

            let resultResp = await fetch(global.rxu.config.get_multi_profiles, requestOptions)

            if (resultResp && resultResp.status === 200) {
              let resultJson = await resultResp.json()
              if (resultJson && resultJson.constructor === Array && resultJson.length > 0) {
                for (let oUser of resultJson) {
                  if (oUser && oUser.full_name && objUsers[oUser.Id]) {
                    objUsers[oUser.Id]['full_name'] = oUser.full_name
                    
                    arrUpdateUserDB.push(objUsers[oUser.Id])
                    worker.addUser(oUser.Id, objUsers[oUser.Id])
                  }
                }    
              }
            } else {
              checkBreak = true
            }

            if (arrUpdateUserDB.length > 0) {
              chatDB.users.bulkPut(arrUpdateUserDB)
            }

          } catch(e1) {
            checkBreak = true 
          }
          
        }

        await new Promise(r => setTimeout(r, 60000));
      }
    } catch(e) {
      // console.log(e.message)
    }
  }
}

export function clearIndexedDB () {
  let timenow = Math.floor(Date.now() / 1000)
  let datenow = ((timenow + 25200) - (timenow + 25200) % (86400)) - 25200
  let date7before = datenow - (7*86400)
  chatDB.mess.where('created_at').below((date7before*1000).toString()).delete().then((deleteCount) => {
    console.log( "Deleted " + deleteCount + " objects");
  })
}

export function checkBlock(group, userid) {
  let isBlocked = 0
  try {
    if (group && group.type && group.type === 3 && group.blocked_uins) {
      group.blocked_uins.map(i => {
        let index = group.occupants_uins.indexOf(i.toString())
        if (index !== -1) {
          isBlocked = 1 // mình chặn ng ta
          if (userid && group.occupants_uins[index].toString() === userid.toString()) {
            isBlocked = 2 // mình bị chặn
          }
        }
        return isBlocked
      })
    }
  } catch (error) {  }
  return isBlocked
}
export function checkNameUser(user, userid = '', netauser) {
  let result = ''
  let netaAuthSetting =  global.rxu.json(rxgetLocal('netaAuthSetting'), { groups:{} })
  if (user && (!user.id && user.Id)) user.id = user.Id
  if (user && user.id) {

    if (userid && user.id && user.id.toString() === userid.toString()) {
      result = translate('You')
      if(netauser && netauser.user && netauser.user.name){
        result = netauser.user.name + ' ('+ translate('You')+")"
      }
    } 
    else if(netaAuthSetting.groups && netaAuthSetting.groups[Number(user.id)]){
      result = rxaget(netaAuthSetting.groups[Number(user.id)], 'name', '')
    }
    else {
      let netaContact = global.rxu.json(rxgetLocal('netaContacts'), { status: false, data: {} })
      let objContact = rxaget(netaContact, 'data', {})
      if (user && user.phone) {
        if (objContact && objContact[user.phone]) {
          result = objContact[user.phone]
        } else if (user.full_name) {
          result = user.full_name
        } else {
          result = user.phone
        }
      } else if (user.full_name) {
        result = user.full_name
      }
    }
  }

  return result
}
export function updateUsersOnline(occupants_uins, oldCountMemberOnl, usersStatus, oldUserStatus) {
  try {
    let status = { ...(oldUserStatus || usersStatus) }, isChange = false, countMemberOnl = 0
    let { id } = (rxgetLocal('rxuserneta') &&
      global.rxu.json(rxgetLocal('rxuserneta'), { user: {} }).user)||{}
    occupants_uins && occupants_uins.map(i => {
      if (!status[Number(i)]) {
        status[Number(i)] = {
          online_status: 2,
          message_status: "",
          last_seen_at: 0,
        }
        isChange = true
      }
      if (usersStatus[Number(i)] && usersStatus[Number(i)].online_status !== status[Number(i)].online_status) {
        delete usersStatus[Number(i)].uin
        status[Number(i)] = usersStatus[Number(i)]
        isChange = true
      }
      if (Number(i) === Number(id)) {
        status[Number(i)] = {
          online_status: 1,
          message_status: "",
          last_seen_at: 0,
        }
      }
      return
    })
    Object.keys(status).map(i => {
      if (occupants_uins.indexOf(i.toString()) === -1) {
        delete status[i]
        isChange = true
      } else {
        if (status[Number(i)].online_status === 1) countMemberOnl += 1
      }
    })
    if (countMemberOnl !== oldCountMemberOnl) isChange = true
    return { isChange, usersStatus: { ...status }, countMemberOnl: countMemberOnl }
  } catch(e) {return{}} 
}
export function checkNameGroup (group, users, userid) { 
  let result = ''
  try {
    if (users) {
      if (group && group.type === 3) {
        // let netaAuthSetting =  global.rxu.json(rxgetLocal('netaAuthSetting'), { groups:{} })
        // if(netaAuthSetting.groups && netaAuthSetting.groups[Number(group.group_id)]){
        //   result = rxaget(netaAuthSetting.groups[Number(group.group_id)], 'name', '')

        //   if (!result) {
        //     let usertmp = users[group.owner_uin.toString()]
        //     const partnerUin = global.rxu.array(rxaget(group, 'occupants_uins', [])).filter(ele => (ele.toString() !== userid.toString()))
        //     if (partnerUin.length > 0) { usertmp = users[partnerUin[0].toString()] }
        //     result = checkNameUser(usertmp)
        //   }
        // } else if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length === 2 && userid && group.occupants_uins.indexOf(userid.toString()) !== -1) {
        //   const arruserid = group.occupants_uins.filter(o => o !== userid.toString())
        //   if (arruserid && arruserid.constructor === Array) {
        //     const user = users[arruserid[0]]
        //     result = checkNameUser(user)
        //   }
        // } else if (group && group.owner_uin) {
        //   let usertmp = users[group.owner_uin.toString()]
        //   const partnerUin = global.rxu.array(rxaget(group, 'occupants_uins', [])).filter(ele => (ele.toString() !== userid.toString()))
          
        //   if (partnerUin.length > 0) {
        //     usertmp = users[partnerUin[0].toString()]
        //   }
        //   result = checkNameUser(usertmp)

        // } else {
        //   result = checkNameUser(users[group.owner_uin.toString()]) || group.name
        // }
      } else {
        if (group && !group.name) {
          const occupants_uins = group.occupants_uins || []
          if (occupants_uins && occupants_uins.length > 0) {
            const groupname = []
            occupants_uins.forEach(uin => {
              const fullname = (users[uin.toString()]) ? checkNameUser(users[uin.toString()]) : ''
              if (fullname) {
                groupname.push(fullname)
              }
            })
            result = groupname.join(', ')
          }
        } else {
          result = rxaget(group, 'name', '')
        }
      }
    }
  } catch (e) {
    // console.log(e)
  }

  if (group && group.isDraft && group.group_fullname !== '' ) {
    return (group.fullnamegroup) ? group.fullnamegroup : group.group_fullname || ''
  } else {
    return result || translate('Stranger')
  }
  
}
export function getGroupById (group, users, userid) { 
  let result = 0
  try {
    if (users) {
      if (group && group.type === 3) {
        if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length === 2 && userid && group.occupants_uins.indexOf(userid.toString()) !== -1) {
          const arruserid = group.occupants_uins.filter(o => o !== userid.toString())
          if (arruserid && arruserid.constructor === Array) {
            result = users[arruserid[0]]
          }
        } 
      } else {
        //console.log('CAN NOT CHECK ID FOR GROUP HAVE MANY MEMBER')
      }
    }
  } catch (e) {
  }

  return result 
}

export function checkAvatarGroup (group, users, userid) {
  let result = false
  try {
    if (group && group.avatar_url) {
      result = true
    } else if (group && group.type === 3 && !group.avatar_url) {
      if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length === 2 && userid && group.occupants_uins.indexOf(userid.toString()) !== -1) {
        const arruserid = group.occupants_uins.filter(o => o !== userid.toString())
        if (arruserid && arruserid.constructor === Array && arruserid[0] && users[arruserid[0]] && users[arruserid[0]].profile_url) {
          result = true
        }
      }
    }
  } catch (e) {}

  return result
}

export function checkName (uid, users, type) {
  if (uid) {
    const username = rxaget(users, uid + '', {})

    if (!type) {
      return (username.full_name) ? username.full_name : (username.name_contact) ? username.name_contact : ''
    } else {
      let fullname = username.name_contact || username.full_name
      if (fullname) {
        fullname = rxChangeSlug(fullname).slice(0, 2).toUpperCase()
        return fullname || ''
      } else {
        return ''
      }
    }
  } else {
    return ''
  }
}

export function checkNameContact (user) {
  let result = ''
  if (user) {
    if (user.name_contact) {
      result = user.name_contact
    } else if (user.full_name) {
      result = user.full_name
    } else if (user.phone) {
      result = user.phone
    } else {
      result = translate('Stranger')
    }
  }

  return result
}

export function checkAvatarSender (omess, users) {
  let result = false
  if (users && omess && omess.sender_uin && users[omess.sender_uin.toString()] && users[omess.sender_uin.toString()].profile_url) {
    result = true
  }
  return result
}

export function checkAvatarSenderTagName (users, userId) {
  if (users && users[userId] && users[userId].profile_url) return true
  return false
}

export function checkIsOwner (omess, userid) {
  if (userid && rxaget(omess, 'sender_uin', '').toString() === userid.toString()) {
    return true
  } else {
    return false
  }
}

export function parseMessageDesc (objmsg, users, userid, adminUins) {
  let message = ''
  let attachments = {}
  if (objmsg) {
    if (!isNaN(objmsg.type)) {
      try {
        attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, ''))
      } catch (e) {
        if (typeof (rxaget(objmsg, 'attachments', '')) === 'object') {
          attachments = rxaget(objmsg, 'attachments', '')
        }
      }
      if (objmsg.status !== 4) {
        if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
          message = getDeleteMessStr( objmsg, worker.users, userid)
        } else {
          let mess =''
          switch (objmsg.type) {
            case 1:
              let call_name = ''
              mess = translate(' finished')
              if (attachments.media_type === 1) {
                call_name = translate('Voice call')
              } else if (attachments.media_type === 2) {
                call_name = translate('Video call')
              }

              if (attachments.accepted_at === '0') {
                message = (attachments && attachments.caller_uin.toString() === userid.toString()) ? translate('Canceled Call') : translate('Missed Call')
              } else {
                message = call_name + mess
              }
              break
            case 2:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name)+ ": "+ translate('Image')
              break
            case 3:
              message = 'Audio'
              break
            case 4:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name)+ ": "+ 'Video'
              break
            case 5:
              if(typeof objmsg.sender_uin === 'number'){
                objmsg.sender_uin = String(objmsg.sender_uin)
              }

              if(objmsg.group_type === 4){
                mess = translate(' created a channel')
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + mess
              }else if (objmsg.group_type !== 3) {
                mess = translate(' created a group')
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + mess 
              } else {
                try {
                  let receiver_uin = objmsg.recipient_uins.filter(uin => uin.toString() != userid.toString())  
                  if (receiver_uin && receiver_uin.length > 0) {
                    mess = translate('Start chat with ')
                    message = mess + checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name)
                  }
                } catch(e3) {
                }
              }
            
              break
            case 6:
              const userins = []
              if(typeof objmsg.sender_uin === 'number'){
                objmsg.sender_uin = String(objmsg.sender_uin)
              }
              try {
                if (attachments && attachments.added_uins && attachments.added_uins.constructor === Array && attachments.added_uins.length > 0) {
                  for (const uid of attachments.added_uins) {
                    const uname = checkNameUser(rxaget(worker.users, uid.toString(), {}))
                    // const uname = checkSenderName(objmsg.sender_name, checkNameUser(rxaget(worker.users, uid.toString(), {}),userid))

                    if (uname) {
                      userins.push(uname)
                    }
                  }
                }
              } catch (e) {
                console.log(e)
              }
              if (userins.length > 0) {                

                mess = translate(' added ')
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + mess + userins.join(', ')
              }
              else if (attachments.removed_uins && attachments.removed_uins.constructor === Array && attachments.removed_uins.length > 0) {
                try {
                  let rmMem = []
                  for (const uid of attachments.removed_uins) {
                    const uname = checkNameUser(rxaget(worker.users, uid.toString(), {}))
                    if (uname) {
                      rmMem.push(uname)
                    }
                  }
                  if (rmMem.length > 0) {
                    mess = translate(' removed ')
                    message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}), userid), objmsg.sender_name) + mess + rmMem.join(', ')
                  }
                } catch (error) {console.log("prasemess",error) }
              }
              else if (attachments.type === 'change_owner' && attachments.owner_uin) {
                message = (checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}))) + translate(' promoted ')
                  + (checkNameUser(rxaget(worker.users, (attachments.owner_uin).toString(), {}))) + translate(' to group owner')
              }
              else if (attachments.added_admins && attachments.added_admins.constructor === Array && attachments.added_admins.length > 0) {
                try {
                  let rmMem = []
                  for (const uid of attachments.added_admins) {
                    const uname = checkNameUser(rxaget(worker.users, uid.toString(), {}))
                    if (uname) {
                      rmMem.push(uname)
                    }
                  }
                  if (rmMem.length > 0) {
                    mess = translate(' added ')
                    message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}), userid), objmsg.sender_name) + mess + rmMem.join(', ') + ' ' + translate('to group\'s admins list')
                  }
                } catch (error) {console.log("prasemess",error) }
              }
              else if (attachments.deleted_admins && attachments.deleted_admins.constructor === Array && attachments.deleted_admins.length > 0) {
                try {
                  let rmMem = []
                  for (const uid of attachments.deleted_admins) {
                    const uname = checkNameUser(rxaget(worker.users, uid.toString(), {}))
                    if (uname) {
                      rmMem.push(uname)
                    }
                  }
                  if (rmMem.length > 0) {
                    mess = translate(' removed ')
                    message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}), userid), objmsg.sender_name) + mess + rmMem.join(', ') + ' ' + translate('from group\'s admins list')
                  }
                } catch (error) {console.log("prasemess",error) }
              }  
              // else if(attachments.pin_message){
              //   if (attachments.pin_message.type === -1) {
              //     message = attachments.pin_message.content
              //   }
              //   else
              //     message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {})), objmsg.sender_name) + translate(' pinned one message')
              // } 

              else if(attachments.unpin_all_messages) {
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), userid), objmsg.sender_name) + translate(" unpin all message")
              }
              else if (attachments.pin_message) {
                if(attachments.pin_message.type !== 17){
                  var content = rxaget(attachments, 'pin_message.type', 0) === 0 ? rxaget(attachments, 'pin_message.message', '') : translate(rxaget(attachments, 'pin_message.message', ''))
                  mess = rxaget(attachments, 'pin_message.message') ? (translate(' pinned') + ' "' + content + '"') : translate(' pinned one message')
                  // if (!objmsg.isNoti) {
                  //   if (mess.indexOf('[') !== -1) {
                  //     mess = mess.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<b>$1</b>')
                  //     mess = mess.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
                  //     mess = mess.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
                  //   }
                  // }
                  message = checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), userid) + mess
                }else{
                  mess = translate(' just pinned the poll')
                  message = checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), userid) + mess
                }
              }
              else if (attachments.unpin_message) {
                if(attachments.unpin_message.type !== 17){
                  var content = rxaget(attachments, 'unpin_message.type', 0) === 0 ? rxaget(attachments, 'unpin_message.message', '') : translate(rxaget(attachments, 'unpin_message.message', ''))
                  mess = rxaget(attachments, 'unpin_message.message') ? (translate(' unpin: ') + ' "' + content + '"') : translate(' unpin one message')
                  message = checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), userid) + mess
                }else{
                  mess =  translate(' just unpinned the poll')
                  message = checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), userid) + mess
                }
              }

              else if (attachments && attachments.updated_group_avatar) {
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + translate(' update avatar')
              }
              else if (attachments && attachments.updated_group_name) {
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + translate(' update group name')
              }
              else if (attachments && attachments.type === 'update_group' && (attachments.owner_uin || attachments.admin_uins)) {
                let descMess = translate(' change group admin to: ')
                if (adminUins && adminUins.constructor === Array && adminUins.indexOf(objmsg.sender_uin.toString()) !== -1) {
                  descMess = translate(' add new admin ')
                }
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + descMess
              } else if (attachments && attachments.group_id && attachments.push_all && attachments.push_all.constructor === Array && attachments.push_all.length > 0 ) {
                try {
                  const arrUserNameAdd = []
                  for (const uid of attachments.push_all) {
                    const unameNew = checkSenderName(checkNameUser(rxaget(worker.users, uid.toString(), {})), objmsg.sender_name)
                    if (unameNew) {
                      arrUserNameAdd.push(unameNew)
                    }
                  }
                  if (arrUserNameAdd.length > 0) {
                    message = arrUserNameAdd.join(', ') + translate(' joined group with link')  
                  }
                } catch(e1) {}
              } else if (attachments && attachments.groupcall && attachments.groupcall.groupcall_id) {
                message = 'Group Call'
              } else if (attachments && attachments.type === 'update_group') {
                let groupType = objmsg.group_type
                let groupName = translate('chat')
                if (groupType == 4) {
                  groupName = translate('channel')
                } else if (groupType == 2) { 
                  groupName = translate('group')
                }
                
                message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + translate(' update group info') + groupName
              }
              break
            case 7:
              if(typeof objmsg.sender_uin === 'number'){
                objmsg.sender_uin = String(objmsg.sender_uin)
              }
              mess = translate(' has left the group')
              // message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) + mess
              message = checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid) + mess
              break
            case 8:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) +": "+ objmsg.message
              break
            case 9:
              let messTmp = objmsg.message
              if(objmsg.message?.length === 0){
                messTmp = translate('forwarded a message')

              }

              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) +": "+messTmp
              break
            case 10:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) +": "+'Sticker'
              break
            case 12:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name)+": "+translate('File')
              break
            case 14:
              message = translate('Current Location')
              break
            case 15:
              message = translate('Live Location')
              break
            case 16:
              message = 'Group Call'
              break
            case 17 :
              message = translate('Poll')
              let poll_type = attachments.poll_type
              switch (poll_type) {
                case 2:
                  mess = translate(' have finished voting ')+attachments.question 
                  message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}), userid), objmsg.sender_name)  + mess
                  break;
                case 3:
                  if(attachments.isFirstVote){
                    mess = translate(' participated in a new poll "')+attachments.question  +'"'
                  }else{
                    mess = translate(' changed vote "') + attachments.question +'"'
                  }
                  message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}), userid), objmsg.sender_name)  + mess
                  break
                default:
                  break;
              }
              break

            default:
              message = checkSenderName(checkNameUser(rxaget(worker.users, objmsg.sender_uin, {}),userid), objmsg.sender_name) +": "+objmsg.message || ''
              break
          }
        }
      } else {
        message = getDeleteMessStr( objmsg, worker.users, userid)
      }
    } else {
      if (objmsg.status !== 4) {
        if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
          message = getDeleteMessStr( objmsg, worker.users, userid)
        } else {
          message = objmsg.message || ''
        }
      } else {
        message = getDeleteMessStr( objmsg, worker.users, userid)
      }
    }

    if (message && message.indexOf('@') !== -1) {
      const userstag = message.match(/(@\d+\b)/ig)
      if (userstag && userstag.constructor === Array && userstag.length > 0) {
        userstag.forEach(o => {
          const useridtmp = o.replace('@', '') || ''
          if (worker.users[useridtmp]) {
            message = message.replace(o, rxaget(worker.users[useridtmp],'full_name', rxaget(worker.users[useridtmp], 'phone', '@')))
          }
        })
      }
    }
    // console.log(message,"??",objmsg.type)
    if (message && message.indexOf('\\n') !== -1) {
      message = message.replace(/\\n/g, ' ')
    }

    if (message.indexOf('[') !== -1) {
      message = message.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '$1')
      message = message.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '$1')
      message = message.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '$1')
    }

    return message || ''
  } else {
    return ''
  }
}


export function checkSenderName(username, sendername) {
  if (sendername && username != translate('Stranger')) {
    return sendername
  } else {
    return username
  }
}

export function getDeleteMessStr(objmsg,users,userid){
  let user = ''
  if(userid && objmsg.sender_uin && userid.toString() === objmsg.sender_uin.toString()){
    user = translate('You')
  }else{
    user = checkNameUser(rxaget(users, objmsg.sender_uin.toString(), {})) 
  }
  let message = user + translate(' unsent a message')
  return message
}

export function getAttachments(objmsg){
  let attachments
  try {
    attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, '').replace(/\\/g, '\\\\'))
  } catch (e) {
    try {
      attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, ''))
    } catch(e2) {
      if (typeof (rxaget(objmsg, 'attachments', '')) === 'object') {
        attachments = rxaget(objmsg, 'attachments', '')
      }  
    }
  }
  return attachments
}